import _taggedTemplateLiteral from "/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import styled from 'styled-components';
export const Container = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: start;\n  font-size: var(--font-size-xxxs);\n  color: ", ";\n"])), _ref => {
  let {
    isError
  } = _ref;
  return isError ? 'var(--color-feedback-error-100)' : 'var(--color-neutral-130)';
});
export const Icon = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  margin-right: var(--spacing-0-5);\n"])));